"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import styles from "./HeroSection.module.css";
import DateSelector from "./DateSelector";
import FeatureCard from "./FeatureCard";
import { IconArrowRight } from "@tabler/icons-react"; // ← new icon
import DisclaimerModal from "../DisclaimerModal";

export default function HeroSection() {
  const [active, setActive] = useState(1);

  const router = useRouter();
  const [dob, setDob] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);

  const slides = [
    {
      title: "Answer Questions",
      description: "Answer guided YES/NO questions about your child's symptoms.",
      icon: "https://static.thenounproject.com/png/question-icon-7788427-512.png"
    },
    {
      title: "AI Risk Analysis",
      description: "AI analyzes the answers and detects possible genetic risk patterns.",
      icon: "https://static.thenounproject.com/png/finance-ai-analysis-icon-7933020-512.png"
    },
    {
      title: "Receive Summary",
      description: "Get a risk indicator and concise summary with potential genetic disorders.",
      icon: "https://static.thenounproject.com/png/data-analysis-icon-7976775-512.png"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);


  const handleStart = () => {
    if (!dob) {
      alert("Please select Date of Birth");
      return;
    }

    const birthDate = new Date(dob);
    const today = new Date();
    if (birthDate > today) {
      alert("Date of Birth cannot be in the future");
      return;
    }

    setLoading(true);
    const ageInMonths =
      (today.getFullYear() - birthDate.getFullYear()) * 12 +
      (today.getMonth() - birthDate.getMonth());
    const query = new URLSearchParams({ age: ageInMonths.toString() });

    setTimeout(() => {
      router.push(`/pages/assessment?${query.toString()}`);
    }, 500);
  };

  return (
    <section className={styles.heroContainer}>
      <h1 className={styles.heading}>Harness the Power of AI for Genetic Risk Assessment</h1>
      <p className={styles.subText}>From answering a few questions to receiving a detailed report.</p>

      <div className={styles.inputContainer}>
        <DateSelector value={dob} onChange={setDob} />
        <button
          onClick={handleStart}
          className={styles.startButton}
          disabled={loading}
        >
          {loading ? (
            "Starting..."
          ) : (
            <>
              Start
              <IconArrowRight
                size={18}
                stroke={2}
                style={{ marginLeft: "6px", transform: "translateY(1px)" }}
              />
            </>
          )}
        </button>
      </div>


      <div className={styles.dwCarousel}>
        {slides.map((slide, index) => {
          let cardClass = styles.dwCard;

          if (index === active) cardClass += ` ${styles.dwCardActive}`;
          else if (index === (active - 1 + slides.length) % slides.length)
            cardClass += ` ${styles.dwCardPrev}`;
          else if (index === (active + 1) % slides.length)
            cardClass += ` ${styles.dwCardNext}`;
          else cardClass += ` ${styles.dwCardHidden}`;

          return (
            <div key={index} className={cardClass}>
              <div className={styles.dwCardImage}>
                <img
                  src={slide.icon}
                  alt={slide.title}
                  className={styles.slideIcon}
                />
              </div>
              <h3>{slide.title}</h3>
              <p>{slide.description}</p>
            </div>
          );
        })}
      </div>

      <div className={styles.dwDots}>
        {slides.map((_, i) => (
          <span
            key={i}
            className={`${styles.dot} ${i === active ? styles.dotActive : ''}`}
            onClick={() => setActive(i)}
          ></span>
        ))}
      </div>
      <DisclaimerModal
        open={open}
        onClose={() => setOpen(false)}
        onAccept={() => console.log("Accepted")}
      />
    </section>
  );
}
